import { render, staticRenderFns } from "./BeButton.vue?vue&type=template&id=59b3ca58&"
import script from "./BeButton.js?vue&type=script&lang=js&"
export * from "./BeButton.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports